import React from 'react';

import {
  CompanyDetailsFooterStyles,
  FooterTypographyStyles,
} from './CompanyDetailsFooter.styles';

export const CompanyDetailsFooter: React.FC<{
  extraPadding?: boolean;
  noHorizontalPadding?: boolean;
}> = ({ extraPadding, noHorizontalPadding }) => (
  <CompanyDetailsFooterStyles
    $extraPadding={extraPadding}
    $noHorizontalPadding={noHorizontalPadding}
  >
    <FooterTypographyStyles variant="label-small" color="neutral-white">
      SOKARIO LIMITED
    </FooterTypographyStyles>
    <FooterTypographyStyles variant="label-small" color="neutral-white">
      Athalassas, 140, Floor 3, 2024, Lefkosia, Cyprus
    </FooterTypographyStyles>
  </CompanyDetailsFooterStyles>
);
